export const singleParcelPrice = 1300;

export const weightLookup = window.pickup_tiers;

export const clearanceFeeLookup = window.pickup_clearance_fees;
